import { LicenceOptionCard } from "components/licence/options/LicenceOptionCard";
import { licenceOptionsMessages } from "components/licence/options/licenceOptionsMessages";
import { Message } from "shared/components/Message";
import React, { FC } from "react";
import { Col, Row } from "reactstrap";
import { routes } from "routes/routes";

export const LicenceOptions: FC = () => {
    return (
        <main id="main-content" className="container py-4">
            <h1 className="h2-style-if-needed">
                <Message message={licenceOptionsMessages.licenceMenuTitle} />
            </h1>
            <hr aria-hidden="true" />

            <Col sm={{ size: 8, offset: 2 }}>
                <Row>
                    <Col>
                        <Row role="list">
                            <Col role="listitem">
                                <LicenceOptionCard
                                    className={"newLicence"}
                                    navDescriptionText={licenceOptionsMessages.newLicenceDescriptionLabel}
                                    navButtonText={licenceOptionsMessages.newLicenceButton}
                                    navigateTo={routes.licence.index.create({})}
                                />
                            </Col>
                            <Col role="listitem">
                                <LicenceOptionCard
                                    className={"previousLicence"}
                                    navDescriptionText={licenceOptionsMessages.previousLicenceDescriptionLabel}
                                    navButtonText={licenceOptionsMessages.previousLicenceButton}
                                    navigateTo={routes.pets.searchPets.create({})}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </main>
    );
};
